import React from "react";
import { Input } from "../../src/components/ui/input.jsx";
import { Textarea } from "../../src/components/ui/textarea.jsx";
import { Label } from "../../src/components/ui/label.jsx";

export default function TestCaseForm({ testCase, onChange }) {
  const handleChange = (field, value) => {
    onChange(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="title" className="text-slate-700 dark:text-slate-200 font-medium">Test Case Title*</Label>
        {/* Add a data-tour attribute so the tutorial can highlight the title input with a red beacon */}
        <Input
          id="title"
          data-tour="create-title"
          value={testCase.title}
          onChange={(e) => handleChange('title', e.target.value)}
          placeholder="e.g., Property zone validation for Parramatta Council"
          className="mt-2"
        />
        {!testCase.title?.trim() && (
          <p className="text-xs text-orange-600 mt-1">Title is required</p>
        )}
      </div>

      <div>
        <Label htmlFor="user_input" className="text-slate-700 dark:text-slate-200 font-medium">User Input*</Label>
        {/* Add a data-tour attribute so the tutorial can highlight the user input field */}
        <Textarea
          id="user_input"
          data-tour="create-user-input"
          value={testCase.user_input}
          onChange={(e) => handleChange('user_input', e.target.value)}
          placeholder="e.g., I want to build a two-story house on my property in Parramatta"
          className="mt-2 h-24"
        />
        {!testCase.user_input?.trim() && (
          <p className="text-xs text-orange-600 mt-1">User input is required</p>
        )}
      </div>


      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="actual_answer" className="text-slate-700 dark:text-slate-200 font-medium">Actual Response Answer</Label>
          <Textarea
            id="actual_answer"
            data-tour="create-actual-answer"
            value={testCase.actual_response_answer}
            onChange={(e) => handleChange('actual_response_answer', e.target.value)}
            placeholder="Paste the actual AI response answer here..."
            className="mt-2 h-32"
          />
        </div>
        
        <div>
          <Label htmlFor="actual_question" className="text-slate-700 dark:text-slate-200 font-medium">Actual Response Question</Label>
          <Textarea
            id="actual_question"
            value={testCase.actual_response_question}
            onChange={(e) => handleChange('actual_response_question', e.target.value)}
            placeholder="Paste the actual AI response question here..."
            className="mt-2 h-32"
          />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="expected_answer" className="text-slate-700 dark:text-slate-200 font-medium">Expected Response Answer</Label>
          <Textarea
            id="expected_answer"
            data-tour="create-expected-answer"
            value={testCase.expected_response_answer}
            onChange={(e) => handleChange('expected_response_answer', e.target.value)}
            placeholder="e.g., Based on your property details, a two-story house is permitted..."
            className="mt-2 h-32"
          />
        </div>
        
        <div>
          <Label htmlFor="expected_question" className="text-slate-700 dark:text-slate-200 font-medium">Expected Response Question</Label>
          <Textarea
            id="expected_question"
            value={testCase.expected_response_question}
            onChange={(e) => handleChange('expected_response_question', e.target.value)}
            placeholder="e.g., What is the total floor area you're planning for your house?"
            className="mt-2 h-32"
          />
        </div>
      </div>
      {!(testCase.expected_response_answer?.trim() || testCase.expected_response_question?.trim()) && (
        <p className="text-xs text-orange-600">Provide either an expected answer or an expected question</p>
      )}
    </div>
  );
}